import Script from "next/script";
import { CHECKOUT_FRAME_DOMAIN } from "constants/env";

export default function CheckoutScript() {
  let scriptUrl = `${CHECKOUT_FRAME_DOMAIN}/v1/checkout.js`;

  return (
    <Script
      strategy="afterInteractive"
      src={scriptUrl}
    />
  );
}
